import core from './core';
import domains from './domains';

export default {
  domains,
  core,
};
